import { useFetchOrganizationMembershipSummaryQuery } from '@/store';

import { SummaryTile } from '../SummaryTile';

const title = 'Active Members';
const description =
  'Percentage of team members who have listened to LumiQ at any point.';

export const ActiveMembers = () => {
  const { data: membershipSummary, isFetching } =
    useFetchOrganizationMembershipSummaryQuery();

  const { engagedActiveMembers = 0, acceptedInvites = 0 } =
    membershipSummary || {};

  const percentage = `${Math.round((engagedActiveMembers / acceptedInvites) * 100 || 0)}%`;

  return (
    <SummaryTile
      title={title}
      mainStat={percentage}
      description={description}
      isLoading={isFetching}
    />
  );
};
